import { render, staticRenderFns } from "./delivery_form.vue?vue&type=template&id=3e21fae4&"
import script from "./delivery_form.vue?vue&type=script&lang=js&"
export * from "./delivery_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports